import { Button } from '@blueprintjs/core';
import { loan_application } from '@axo/shared/data-access/types';
import { ReactNode } from 'react';
import { useRenewAllFailedDependencies } from '@axo/shared/data-access/hooks/services/loan_application/useRenewAllFailedDependencies.ts';
import styles from '../ApplicationCard.module.css';
import { useCurrentUserHasLock } from '@axo/shared/data-access/hooks/services/lock/useApplicationLock';
import { useApplicationDetail } from '@axo/shared/data-access/hooks/queries/useApplicationDetail';
import { useUpdateApplicationDetails } from '@axo/shared/data-access/hooks/mutations/useUpdateApplicationDetails';

const RETRY_BUTTONS: Partial<
  Record<
    loan_application.ApplicationStatus,
    {
      newStatus: loan_application.ApplicationStatus;
      label: ReactNode;
    }
  >
> = {
  [loan_application.ApplicationStatus.ApplicationStatusValidationFailed]: {
    newStatus:
      loan_application.ApplicationStatus
        .ApplicationStatusPendingReceiptCustomerInputComplete,
    label: 'Revalidate',
  },
  [loan_application.ApplicationStatus.ApplicationStatusBlockedBySanctions]: {
    newStatus: loan_application.ApplicationStatus.ApplicationStatusCompleted,
    label: 'Unblock',
  },
};

export function ActionsContainer({ applicationID }: { applicationID: string }) {
  const app = useApplicationDetail(applicationID);

  const hasLock = useCurrentUserHasLock(app.data?.ID, app.data?.MarketCountry);

  const { isLoading: isUpdatingApplication, mutateAsync: updateApplication } =
    useUpdateApplicationDetails();

  const { isLoading: isRenewingFailedDependencies, renewAll } =
    useRenewAllFailedDependencies(applicationID);

  const retryButton = app.data?.Status
    ? RETRY_BUTTONS[app.data?.Status]
    : undefined;

  return (
    <div className={styles.actionsContainer}>
      {app.data?.Status ===
        loan_application.ApplicationStatus
          .ApplicationStatusFetchingExternalDataFailed && (
        <Button
          disabled={!hasLock.data || isRenewingFailedDependencies}
          onClick={renewAll}
        >
          Refetch
        </Button>
      )}
      {retryButton && (
        <Button
          disabled={isUpdatingApplication || !hasLock.data}
          onClick={() => {
            updateApplication({
              applicationID,
              patch: {
                Status: retryButton.newStatus,
              },
            });
          }}
        >
          {retryButton.label}
        </Button>
      )}
    </div>
  );
}
